import React, { useState, useEffect } from 'react';
import SessionStore from 'stores/SessionStore';
import UserWebAPIUtils from 'utils/UserWebAPIUtils';
import ToastStore, { showToast } from 'stores/ToastStore';
function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
const SupportRequestVerification = (props) => {
    const [loaded, setLoaded] = useState(false);
    const [redirect, setRedirect] = useState(null);
    const fetchData = async (id, jwt) => {
        return await UserWebAPIUtils.createSupportRequestGrant(id, jwt).catch((e) => {
            console.log(e);
        });
    };
    useEffect(async () => {
        const user = SessionStore.getUser();
        console.log('Attempting to link user account to support request', window.location.href);
        const jwt = window.location.href.split('?')[1];
        if (!jwt || !jwt.length) {
            setRedirect('/');
        }
        try {
            // API Call to create the Login As Feature Grant
            const res = await fetchData(user._id, jwt);
            console.log('res', res);
            if (user._type === 'Carrier') {
                setRedirect('/carrier-center');
            }
            else if (user._type === 'Shipper') {
                setRedirect('/profile');
            }
            else {
                setRedirect('/');
            }
            await timeout(2000);
            setLoaded(true);
        }
        catch (e) {
            setRedirect('/');
            setLoaded(true);
            console.log('error linking account access requests', props.match.params.id, 'err:', e.message);
        }
    }, []);
    if (!loaded) {
        return (React.createElement("div", { className: "flex justify-center p-16 font-bold" }, "Attempting to Link Support Request..."));
    }
    window.location.href = redirect;
};
export default SupportRequestVerification;
